// GridPanel.js
import React, { useMemo ,forwardRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { GRID_HEIGH, } from '../../pages/common/StyleConstants';

const GridPanel = forwardRef(({
  rowData,
  columnDefs,
  gridTheme,
  defaultColDef,
  onCellClicked,
  onCellDoubleClicked,
  onRowSelected,
  onSelectionChanged,
  rowSelection,
  ...restEvents
}, ref) => {

  // 기본 defaultColDef을 props로 받거나 내부 생성
  const baseDef = useMemo(() => defaultColDef || ({
      flex:1, 
      minWidth:50, 
      resizable:true,
      filter:false, 
      sortable:true, 
      wrapHeaderText:true,
    }), [defaultColDef]);

  // const defaultColDef = useMemo(() => ({
  //   flex: 1, minWidth: 50, filter: false,
  //   resizable: true, sortable: true, editable: false,
  //   singleClickEdit: true, autoHeaderHeight: true,
  //   wrapHeaderText: true, suppressMovable: true,
  // }), []);

  return (
    <div style={{ height: '100%', width: '100%' }} className={gridTheme}>
      <AgGridReact
        ref={ref}  
        defaultColDef={baseDef} 
        rowData={rowData}
        columnDefs={columnDefs}
        rowSelection={rowSelection?rowSelection:'single'}
        onCellDoubleClicked={onCellDoubleClicked}
        rowHeight={GRID_HEIGH}
        headerHeight={GRID_HEIGH}
        suppressReactComponentReload={true}
        {...restEvents}
      />
    </div>
  );
});

export default React.memo(GridPanel);
;
